export function isValidVimeoLink(url: string) {
  if (!url) return false;
  try {
    const parsedUrl = new URL(
      url.startsWith('https://') || url.startsWith('http://')
        ? url
        : `https://${url}`
    );
    const hostname = parsedUrl.hostname.toLowerCase();
    const pathname = parsedUrl.pathname.toLowerCase();

    if (hostname === 'vimeo.com' || hostname === 'player.vimeo.com') {
      const videoId = extractVimeoVideoId(pathname);
      return videoId !== null;
    }

    return false;
  } catch (error) {
    return false;
  }
}

function extractVimeoVideoId(pathname: string) {
  const regex = /^\/(?:video\/)?(\d+)(?:\/|\b)/;
  const match = pathname.match(regex);

  if (match && match[1]) {
    return match[1];
  }

  return null;
}
